import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap items-center justify-end sm:justify-between py-3 px-6 border-b border-gray-100 gap-3 leading-8"
}
const _hoisted_2 = { class: "flex flex-wrap items-center justify-start sm:justify-end gap-x-6" }

import { MedKitIcon, Icon } from '@bigpicturemedical/medkit'
import { PropType } from 'vue'
import { BlockHeaderIntent } from './blockLayoutProps'


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockPanelHeader',
  props: {
  title: {
    type: String,
    default: ''
  },
  icon: {
    type: String as PropType<Icon>,
    default: ''
  },
  intent: {
    type: String as PropType<BlockHeaderIntent>,
    default: BlockHeaderIntent.primary,
    validator(value:BlockHeaderIntent) {
      return Object.values(BlockHeaderIntent).includes(value)
    },
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.title)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        (__props.icon)
          ? (_openBlock(), _createBlock(_unref(MedKitIcon), {
              key: 0,
              icon: __props.icon,
              size: "medium"
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        _createElementVNode("h2", {
          class: _normalizeClass(["grow font-semibold text-gray-900", [__props.intent === _unref(BlockHeaderIntent).primary ? 'text-lg' : '']])
        }, _toDisplayString(__props.title), 3),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})